import {hubConnection} from "signalr-no-jquery";

const printerTemplate = {
    INSERT_NORM_REQUEST: `${window.ENV.MAIN_SERVER}/Reports/Forms/Form_SectionNormRequest.mrt`,
    INSERT_ORG_REQUEST: `${window.ENV.MAIN_SERVER}/Reports/Forms/Form_HospitalNormRequest.mrt`,
    NORM_REQUEST_SAMPLING_LABEL: `${window.ENV.MAIN_SERVER}/Reports/Labels/Label_Sampling.mrt`,
    CROSS_MATCH_LABEL: `${window.ENV.MAIN_SERVER}/Reports/Labels/Label_CrossMatch.mrt`,
    OUTGOING_LABEL: `${window.ENV.MAIN_SERVER}/Reports/Labels/Label_Outgoing.mrt`,
    OUTGOING_FORM_ENZYME_TYPE_1: `${window.ENV.MAIN_SERVER}/Reports/Forms/Form_RBC-WB-RedCells.mrt`,
    OUTGOING_FORM_OTHER_ENZYME_TYPE: `${window.ENV.MAIN_SERVER}/Reports/Forms/Form_FFP-PLT-CRY.mrt`
};

class Printer {
    printers = null;
    connection = null;
    hub = null;
    events = null;
    resolve = null;
    reject = null;

    init(props = {}) {
        this.props = {
            onConnect: _ => null,
            onDisconnect: _ => null,
            onReconnecting: _ => null,
            onReconnected: _ => null,
            onPrinterListChange: _ => null,
            onError: _ => null,
            port: window.ENV.PRINTER_SW_PORT,
            ...props
        };

        const cls = this;
        this.connection = hubConnection(`http${window.ENV.PRINTER_SW_SSL === 'true' ? 's' : ''}://${window.ENV.PRINTER_SW_IP}:${cls.props.port}/signalr/hubs`);
        this.hub = this.connection.createHubProxy('PrinterHub');

        this.hub.on('receivedDataFromServer', function (message) {
            // eslint-disable-next-line eqeqeq
            if (message.ResultCode == 0) {
                try {
                    const printers = JSON.parse(message.ResultMessage).PrinterNames;

                    if (!cls.printers)
                        cls.props.onPrinterListChange(printers);

                    cls.printers = printers;
                } catch (e) {
                    if (message.ResultMessage === 'True') {
                        if (cls.resolve)
                            cls.resolve();
                    } else if (message.ResultMessage === 'False') {
                        if (cls.reject)
                            cls.reject();
                    }
                }
            }
        });

        this.connection.start()
            .done(_ => {
                cls.props.onConnect();

                cls.requestPrinterList();
            })
            .fail(_ => {
                cls.props.onError();
            });
    }

    print(data) {
        return new Promise((resolve, reject) => {
            this.resolve = resolve;
            this.reject = reject;

            for (let item of data) {
                const d = {
                    Command: "Print",
                    obj: {
                        PrinterName: item.printerName,
                        PrintCount: item.count,
                        ShowPrinterSetting: item.settingsPreview,
                        PrintPreview: item.printPreview,
                        PrintTemplateUrl: item.template,
                        PrintFormValues: item?.parameters || null,
                        PrintFormDatatables: item?.datatables || null,
                    },
                };

                this.hub.invoke('sendDataToServer', JSON.stringify(d));
            }
        });
    }

    requestPrinterList() {
        this.hub.invoke('sendDataToServer', JSON.stringify({"Command": "GetPrinterList", "obj": null}));
    }
}

export default Printer
export {printerTemplate}